import { StoreState } from '@/store/interfaces';

export const state: StoreState = {
  page_language: 'pl',
};
